(() => {
  const COOKIE_NAME = "scs_gift_code";
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days
  const ATTEMPT_KEY_PREFIX = "scs_gift_attempted:";

  function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  }

  async function isCodeAlreadyApplied(code) {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return false;
      const cart = await res.json();
      const codes = cart.discount_codes || [];
      return codes.some((c) => c.code === code && c.applicable);
    } catch {
      return false;
    }
  }

  async function activateGiftCode(code) {
    const attemptKey = `${ATTEMPT_KEY_PREFIX}${code}`;
    if (sessionStorage.getItem(attemptKey)) return;

    if (await isCodeAlreadyApplied(code)) return;

    sessionStorage.setItem(attemptKey, "1");
    const redirectTo = window.location.pathname + window.location.search.replace(/([?&])promoCode=[^&]*&?/, "$1").replace(/[?&]$/, "");
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectTo || "/")}`;
  }

  function init() {
    const params = new URLSearchParams(window.location.search);
    const promoCode = params.get("promoCode");

    if (promoCode) {
      setCookie(COOKIE_NAME, promoCode);
    }

    const activeCode = promoCode || getCookie(COOKIE_NAME);
    if (activeCode) activateGiftCode(activeCode);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
